/**
 * Bumped on each list switch, so a slow fetch chain for a list the user has
 * left cannot overwrite the new list's data. Outside redux because the store
 * is persisted.
 */
let generation = 0;

export const startFetchGeneration = () => ++generation;

export const currentFetchGeneration = () => generation;

export const isCurrentFetchGeneration = (candidate: number) =>
    candidate === generation;
